import React from "react";
import { money, refundableLabel, TierTable } from "./FeeStructureDetails";
import { sortVersions } from "./feeStructureModel";

export default function FeeStructureVersionsTable({ versions, category }) {
  const financialPlanning = category === "financial-planning";
  const fees = sortVersions(versions);
  return <div className="fee-table-scroll"><table className={`fee-table fee-versions-table${financialPlanning ? " fee-versions-table--fp" : ""}`} aria-label="Fee versions">
    <colgroup>
      {(financialPlanning ? [240, 260, 360, 360] : [240, 160, 160, 660]).map((width, index) => <col key={index} style={{ width: `${width}px` }} />)}
    </colgroup>
    <thead>
      <tr>
        <th scope="col" className="FP_Help_Text_Semibold">Client Agreement Version</th>
        {financialPlanning ? <>
          <th scope="col" className="FP_Help_Text_Semibold">Fixed Fee (£) / Refundable</th>
          <th scope="col" className="FP_Help_Text_Semibold">Progressive Tiered Fee Structure</th>
          <th scope="col" className="FP_Help_Text_Semibold">Ongoing Fee (%)</th>
        </> : <>
          <th scope="col" className="FP_Help_Text_Semibold">Fixed Fee (£)</th>
          <th scope="col" className="FP_Help_Text_Semibold">Refundable</th>
          <th scope="col" className="FP_Help_Text_Semibold">Fee With Variation</th>
        </>}
      </tr>
      {financialPlanning && <tr className="fee-rate-headings">
        <th aria-hidden="true" /><th aria-hidden="true" />
        {["Progressive tiers", "Ongoing tiers"].map(label => <th key={label}><div className="fee-tier-column-headings" aria-label={label}><span className="FP_Help_Text_Semibold">{label === "Ongoing tiers" ? "Rate (% p.a.)" : "Rate (%)"}</span><span className="FP_Help_Text_Semibold">From</span><span className="FP_Help_Text_Semibold">To</span></div></th>)}
      </tr>}
    </thead>
    <tbody>{fees.map((fee, index) => <tr key={fee.id} className="fee-adviser-row" style={{ "--fee-row-background": index % 2 ? "var(--Blue200)" : "var(--White)" }}>
      <td>{fee.version}</td>
      {financialPlanning ? <>
        <td>{money(fee.fixedFee)} / {refundableLabel(fee.refundable)}</td>
        <td><TierTable rows={fee.tiers} showHeader={false} /></td>
        <td>{fee.ongoingType === "tiered" ? <TierTable rows={fee.ongoingTiers} showHeader={false} /> : fee.ongoingRate !== "" && fee.ongoingRate != null ? <TierTable rows={[{ rate: fee.ongoingRate }]} showHeader={false} rateOnly /> : "-"}</td>
      </> : <><td>{money(fee.fixedFee)}</td><td>{refundableLabel(fee.refundable)}</td><td className="fee-variation-text">{fee.variations || "-"}</td></>}
    </tr>)}{!fees.length && <tr><td colSpan={4}>No fee structure saved yet.</td></tr>}</tbody>
  </table></div>;
}
